module.exports = __webpack_public_path__ + "static/media/bee.6177f8f9.png";